import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { useHeaderRootContext } from '../../HeaderRoot/context/hooks/useHeaderRootContext.js';
import { HEADER_ICON_BUTTON_STYLE } from '../../../constants.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

/**
 * Hook for generating back button props based on header transparency and user props
 */
var useHeaderBackButton = function useHeaderBackButton(props) {
  var _useHeaderRootContext = useHeaderRootContext(),
    isTransparent = _useHeaderRootContext.isTransparent;
  return {
    backButtonProps: _objectSpread(_objectSpread(_objectSpread({
      iconId: 'fill.arrow.back',
      staticSize: '20',
      color: props.isDisabled ? 'state.disabled' : 'base.default'
    }, HEADER_ICON_BUTTON_STYLE), isTransparent && {
      staticSize: '16',
      backgroundColor: 'base.surface.floating',
      boxShadow: 'bottom-s'
    }), props)
  };
};

export { useHeaderBackButton };
//# sourceMappingURL=useHeaderBackButton.js.map
